export default "__VITE_ASSET__CFlLHYIK__"